/** Drawer menu styles — aligned with Comercial / CallCenter main CRM. */
export const CCC_DRAWER_MENU_STYLES = `
  .crm-hamburger-btn:hover {
    background: transparent !important;
  }
  .crm-drawer-menu .ant-drawer-content {
    background: linear-gradient(180deg, #0f0f0f 0%, #1a1a1a 100%) !important;
    border-top-right-radius: 20px !important;
    border-bottom-right-radius: 20px !important;
    box-shadow: 4px 0 24px 0 rgba(0, 0, 0, 0.5), 0 0 0 1px rgba(239, 68, 68, 0.1) inset !important;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }
  .crm-drawer-menu .ant-drawer-header {
    background: transparent !important;
    border-top-right-radius: 20px !important;
    padding: 20px 24px !important;
  }
  .crm-drawer-menu .ant-drawer-header .ant-drawer-title {
    color: #ef4444 !important;
    font-weight: 600 !important;
    letter-spacing: 0.5px !important;
  }
  .crm-drawer-menu .ant-drawer-close {
    color: #ef4444 !important;
    opacity: 0.8 !important;
    transition: all 0.2s ease !important;
    width: 32px !important;
    height: 32px !important;
    border-radius: 6px !important;
  }
  .crm-drawer-menu .ant-drawer-close:hover {
    color: #fff !important;
    background: rgba(239, 68, 68, 0.15) !important;
    opacity: 1 !important;
  }
  .crm-menu-list .ant-menu-item {
    font-size: 15px !important;
    padding: 12px 20px !important;
    border-radius: 10px !important;
    margin: 4px 8px !important;
    transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
    color: rgba(239, 68, 68, 0.85) !important;
    font-weight: 500 !important;
    height: auto !important;
    line-height: 1.5 !important;
    border: 1px solid transparent !important;
  }
  .crm-menu-list .ant-menu-item .anticon {
    color: rgba(239, 68, 68, 0.85) !important;
    font-size: 18px !important;
    margin-right: 12px !important;
    transition: all 0.25s ease !important;
  }
  .crm-menu-list .ant-menu-item-selected {
    background: linear-gradient(135deg, rgba(239, 68, 68, 0.15) 0%, rgba(239, 68, 68, 0.08) 100%) !important;
    box-shadow: 0 2px 8px rgba(239, 68, 68, 0.2), 0 0 0 1px rgba(239, 68, 68, 0.3) inset !important;
    color: #ef4444 !important;
    font-weight: 600 !important;
    border-color: rgba(239, 68, 68, 0.3) !important;
  }
  .crm-menu-list .ant-menu-item-selected .anticon {
    color: #ef4444 !important;
    transform: scale(1.05) !important;
  }
  .crm-menu-list .ant-menu-item:hover:not(.ant-menu-item-selected) {
    background: rgba(239, 68, 68, 0.08) !important;
    color: #ef4444 !important;
    border-color: rgba(239, 68, 68, 0.15) !important;
    transform: translateX(2px) !important;
  }
  .crm-menu-list .ant-menu-item:hover:not(.ant-menu-item-selected) .anticon {
    color: #ef4444 !important;
    transform: scale(1.05) !important;
  }
  .crm-menu-list .ant-menu-item:active {
    transform: translateX(1px) scale(0.98) !important;
  }
`;
